import { render, staticRenderFns } from "./loginSVG.vue?vue&type=template&id=3530a72e&scoped=true"
import script from "./loginSVG.vue?vue&type=script&lang=js"
export * from "./loginSVG.vue?vue&type=script&lang=js"
import style0 from "./loginSVG.vue?vue&type=style&index=0&id=3530a72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530a72e",
  null
  
)

export default component.exports